import { makeAutoObservable, runInAction } from "mobx";

import { MemberApi } from "@/models/api/MemberApi";

import type { TeamModel } from "./TeamModel";
import type { Membership, UserShort } from "@/api";
import type { MemberRole } from "@/models/api/MemberApi";

export class MemberModel {
  private api: MemberApi;

  team: TeamModel;

  constructor(memberData: Membership, team: TeamModel) {
    this.api = new MemberApi(memberData);
    this.team = team;
    makeAutoObservable(this);
  }

  get id(): string {
    return this.api.memberData.id;
  }

  get user(): UserShort {
    return this.api.memberData.user;
  }

  get role(): MemberRole {
    return this.api.memberData.accessLevel as MemberRole;
  }

  async updateRole(role: MemberRole) {
    return this.api.updateRole(role);
  }

  async remove() {
    await this.api.remove();
    runInAction(() => {
      if (this.team.membersUX) {
        const currentMembers = this.team.membersUX.members;
        runInAction(() => {
          this.team.membersUX.members = currentMembers.filter((m) => m.id !== this.id);
        });
      }
    });
  }
}
